import { FC } from "react"

import { Typography } from "@mui/material"

interface IProps {
  text: string
  onClick: () => void
}

const ListItem: FC<IProps> = ({ text, onClick }) => {
  return (
    <Typography
      role="menuitem"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault()
          onClick()
        }
      }}
      variant="body2"
      minWidth="190px"
      fontWeight={500}
      color="mockup.neutral10"
      px="16px"
      py="12px"
      sx={{
        cursor: "pointer",
        "&:hover": {
          background: (theme) => theme.palette.mockup.primary99,
        },
        "&:focus-visible": {
          outline: (theme) => `2px solid ${theme.palette.primary.main}`,
          outlineOffset: "-2px",
        },
      }}
    >
      {text}
    </Typography>
  )
}

export default ListItem
